export const UPDATE_COMPANY_INFO = 'update_company_info';
export const ADD_SYSLOG_SERVER = 'add_syslog_server';
export const UPDATE_SYSLOG_SERVERS = 'update_syslog_servers';
export const REMOVE_SYSLOG_SERVER = 'remove_syslog_server';
export const UPDATE_SMTP_SERVER = 'update_smtp_server';
export const ADD_RADIUS_CLIENT = 'add_radius_client';
export const REMOVE_RADIUS_CLIENT = 'remove_radius_client';
export const UPDATE_RADIUS_CLIENT = 'update_radius_client';
export const UPDATE_FAIL_CLOSE_FIELD = 'update_fail_close_field';
export const ADD_FAIL_CLOSE_VALUE = 'add_fail_close_value';
export const REMOVE_FAIL_CLOSE_VALUE = 'remove_fail_close_value';
export const UPDATE_SELECTIVE_FWD_FIELD = 'update_selective_fwd_field';
export const ADD_SELECTIVE_FWD_VALUE = 'add_selective_fw_value';
export const REMOVE_SELECTIVE_FWD_VALUE = 'remove_selective_fw_value';
export const SWITCH_EXCHANGE_SERVERS = 'switch_exchange_servers';
